class VwKurumbonustanimdetayDTO {
    id: number = 0;
    fkBonustanimId?: number = null;
    fkIslemtanimId?: number = null;
    oran?: number = null;
    ekleyenKullanici?: number = null;
    eklemeTarih?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptalTarihi?: string = null;
    iptalKullanici?: number = null;
    iptalNedenId?: number = null;
    iptalAciklama?: string = "";
    fkKurumId?: number = null;
    kurumAdi?: string = "";
    bonusTanimOran?: number = null;
    islemAdi?: string = "";
};
export default VwKurumbonustanimdetayDTO;